export const SET_USER_SCHEDULES_LOADED = "SET_USER_SCHEDULES_LOADED";

export const setUserSchedulesLoaded = (userSchedulesLoaded: boolean) => {
  return {
    userSchedulesLoaded,
    // tslint:disable-next-line:object-literal-sort-keys
    type: SET_USER_SCHEDULES_LOADED
  };
};
